export enum FeedType {
  Global = "Global",
  Personal = "Personal",
}
